const { theme } = require('antd');
const { Flex, Typography } = require('zui/Antd');
const { Text } = Typography;

// ─── Stat card (reusable) ─────────────────────────────────────────────────────
const StatCard = ({ value, label, color, bgColor }) => {
	const {
		token: { fontSizeSM, colorBgLayout }
	} = theme.useToken();
	return (
		<Flex
			vertical
			align='center'
			justify='center'
			style={{
				flex: 1,
				padding: '10px 12px',
				background: bgColor || colorBgLayout,
				borderRadius: 6,
				textAlign: 'center'
			}}
		>
			<Text strong style={{ fontSize: 22, color, lineHeight: 1.2 }}>
				{value}
			</Text>
			<Text type='secondary' style={{ fontSize: fontSizeSM, marginTop: 2 }}>
				{label}
			</Text>
		</Flex>
	);
};

export default StatCard;
